(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["palmares-badge-styles"] && !Shopify.designMode) return;
  try {
    if (!window.__palmaresImageModalInitialized) {
    window.__palmaresImageModalInitialized = true;

    let modal = null;
    let modalImage = null;
    let closeButton = null;
    let previousFocus = null;
    let pointerStart = null;
    let suppressNextClickTrigger = null;

    const createModal = () => {
      modal = document.createElement('div');
      modal.className = 'palmares-image-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Palmares image');

      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'palmares-image-modal__close';
      closeButton.setAttribute('aria-label', 'Close');
      closeButton.innerHTML = '&times;';

      modalImage = document.createElement('img');
      modalImage.className = 'palmares-image-modal__image';
      modalImage.alt = '';

      modal.append(closeButton, modalImage);
      document.body.append(modal);
    };

    const closeModal = () => {
      if (!modal || modal.hidden) return;

      modal.hidden = true;
      modalImage.removeAttribute('src');
      document.documentElement.classList.remove('palmares-image-modal-open');

      if (previousFocus instanceof HTMLElement) {
        previousFocus.focus();
      } else if (closeButton instanceof HTMLElement) {
        closeButton.blur();
      }

      previousFocus = null;
    };

    const openModal = (trigger, restoreFocus = true) => {
      const imageUrl = trigger.dataset.palmaresModalImage;
      if (!imageUrl) return;

      if (!modal) {
        createModal();
        closeButton.addEventListener('click', closeModal);
      }

      previousFocus = restoreFocus ? trigger : null;
      modalImage.src = imageUrl;
      modalImage.alt = trigger.dataset.palmaresModalAlt || '';
      modal.hidden = false;
      document.documentElement.classList.add('palmares-image-modal-open');
      closeButton.focus();
    };

    document.addEventListener(
      'pointerdown',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const trigger = target?.closest('[data-palmares-carousel-modal-trigger]');

        pointerStart =
          trigger instanceof HTMLElement && trigger.closest('.palmares-carousel--image-modal-enabled')
            ? {
                trigger,
                x: event.clientX,
                y: event.clientY,
              }
            : null;
      },
      true,
    );

    document.addEventListener(
      'pointerup',
      (event) => {
        if (!pointerStart) return;

        const movedX = Math.abs(event.clientX - pointerStart.x);
        const movedY = Math.abs(event.clientY - pointerStart.y);
        const isTap = movedX < 24 && movedY < 24;
        const activeTrigger = pointerStart.trigger;

        pointerStart = null;

        if (!isTap) return;

        suppressNextClickTrigger = activeTrigger;
        openModal(activeTrigger, false);
      },
      true,
    );

    document.addEventListener(
      'pointercancel',
      () => {
        pointerStart = null;
      },
      true,
    );

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const trigger = target.closest('[data-palmares-carousel-modal-trigger]');
        if (trigger instanceof HTMLElement && trigger.closest('.palmares-carousel--image-modal-enabled')) {
          event.preventDefault();

          if (trigger === suppressNextClickTrigger) {
            suppressNextClickTrigger = null;
            return;
          }

          openModal(trigger);
          return;
        }

        if (modal && !modal.hidden && target === modal) {
          closeModal();
        }
      },
      true,
    );

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key === 'Tab') {
        event.preventDefault();
        closeButton.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
